import { Stack } from '@mui/joy'
import { useStore } from 'effector-react'
import { Trans, useTranslation } from 'react-i18next'
import { driverModel } from '~/entities/common/Driver'
import { Alert } from '~/shared/ui/Alerts'

type AlertsProps = {
  driverId: string
}

export function Alerts({ driverId }: AlertsProps) {
  const { t } = useTranslation()

  const driver = useStore(driverModel.$driver)
  const driverIdFromModel = driver?.getApiId()
  const driverLoaded = driverIdFromModel === driverId
  const sentToComandirDate = driver?.getSentToComandirFormattedDate()
  const driverStatus = driver?.getStatus()
  const decisionMaker = driver?.getWhoApprovedOrRejected()
  const decisionDate = driver?.getApprovedOrRejectedFormattedDate()

  const currentStatusTransition = driver?.getCurrentStatusTransition()
  const currentStatusTransitionComment = currentStatusTransition?.getComment()

  const decisionMakerName =
    driverLoaded && decisionMaker
      ? [
          decisionMaker.getName(),
          decisionMaker.getPhone(),
          decisionMaker.getEmail(),
          `${t('in')} ${decisionDate}`,
        ].join(' ')
      : null

  if (!driverLoaded) return null

  return (
    <>
      <Stack spacing={1}>
        {decisionMakerName && (
          <Alert variant='info'>
            <Trans
              i18nKey='alert.driver decision made by'
              values={{ name: decisionMakerName }}
              components={{ b: <b /> }}
            />
          </Alert>
        )}

        {driverStatus === 'SENT_TO_COMANDIR' && sentToComandirDate && (
          <Alert variant='warning'>
            <Trans
              i18nKey='alert.sent to supervisor at'
              values={{ date: sentToComandirDate }}
              components={{ b: <b /> }}
            />
          </Alert>
        )}

        {currentStatusTransitionComment && (
          <Alert variant='warning'>{currentStatusTransitionComment}</Alert>
        )}
      </Stack>
    </>
  )
}
